<template>
  <el-dialog :visible.sync="visible" title="资源列表" :close-on-click-modal="false" :close-on-press-escape="false" width="100%">
    <el-form :inline="true" :model="dataForm">
      <el-form-item>
        <el-input v-model="dataForm.wd" placeholder="资源名字,有的资源搜索功能没用" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.t" filterable placeholder="请选择" @change="getDataList()">
          <el-option
            key=""
            label="全部"
            value=""
            >
          </el-option>
          <el-option
            v-for="item in mcClass"
            :key="item.type_id"
            :label="item.type_name"
            :value="item.type_id"
            >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @sort-change="dataListSortChangeHandle"
      height="400"
      style="width: 100%;">
      <el-table-column prop="vod_id" label="资源ID" header-align="center" align="center" width="80"></el-table-column>
      <el-table-column prop="vod_name" label="资源名字" header-align="center" align="center"></el-table-column>
      <el-table-column prop="type_name" label="资源分类" header-align="center" align="center"></el-table-column>
    
      <el-table-column prop="vod_time" label="更新时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="vod_remarks" label="更新详情" header-align="center" align="center" width="180"></el-table-column>
      <el-table-column prop="vod_id" label="操作" header-align="center" align="center" width="180">
        <template slot-scope="scope">
            <el-button  type="text" size="small" @click="caiji(scope.row.vod_id)">采集本部</el-button>
          </template>
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="caiji(scope.row.vod_id)">采集本部</el-button>
          </template>
        </el-table-column> -->
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[20]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-copy'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        createdIsNeed: false,
        getDataListURL: '/cmsres/cmsresInfo/page',
        getDataListIsPage: true
      },
      mcClass: [],
      dataForm: {
        id: '',
        vid: '',
        t:'',
        wd: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getDataList()
      this.getClass()
      
    },
    // 失败信息
    caiji (id) {
      this.dataForm.vid = id
      this.dataListLoading = true
      this.$http.post(`/cmsres/cmsresInfo/caiji/`,this.dataForm).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          
          return this.$message.error(res.msg)
        }
        
        this.$message({
          message: '采集成功',
          type: 'success'
        });
      }).catch(() => {})
    },
    getClass(){
      this.$http.post(`/cmsres/cmsresInfo/getClass/`,this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.mcClass = res.data
      }).catch(() => {})
    }
  }
}
</script>
